// extracted by mini-css-extract-plugin
module.exports = {"footer":"index_footer__C0ecM","info":"index_info__iVwtP"};